import React from "react";

function InventoryDetailsModal({ item, onClose }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center">
      <div className="bg-white p-6 rounded shadow-lg w-full max-w-lg">
        <h2 className="text-xl font-bold mb-4">Inventory Item Details</h2>
        <div className="space-y-4">
          <div>
            <span className="text-sm font-semibold">Item Name:</span>{" "}
            <span>{item.name}</span>
          </div>
          <div>
            <span className="text-sm font-semibold">SKU:</span>{" "}
            <span>{item.sku}</span>
          </div>
          <div>
            <span className="text-sm font-semibold">Category:</span>{" "}
            <span>{item.category}</span>
          </div>
          <div>
            <span className="text-sm font-semibold">Quantity:</span>{" "}
            <span>{item.quantity}</span>
          </div>
          <div>
            <span className="text-sm font-semibold">Reorder Level:</span>{" "}
            <span>{item.reorderLevel}</span>
          </div>
          <div>
            <span className="text-sm font-semibold">Unit Price:</span>{" "}
            <span>${item.unitPrice.toFixed(2)}</span>
          </div>
          <div>
            <span className="text-sm font-semibold">Total Value:</span>{" "}
            <span>${(item.quantity * item.unitPrice).toFixed(2)}</span>
          </div>
          <div>
            <span className="text-sm font-semibold">Supplier:</span>{" "}
            <span>{item.supplier}</span>
          </div>
          <div>
            <span className="text-sm font-semibold">Status:</span>{" "}
            <span
              className={`px-2 py-1 rounded-full text-sm ${
                item.status === "In Stock"
                  ? "bg-green-100 text-green-600"
                  : item.status === "Low Stock"
                  ? "bg-yellow-100 text-yellow-600"
                  : "bg-red-100 text-red-600"
              }`}
            >
              {item.status}
            </span>
          </div>
        </div>
        <div className="flex justify-end mt-6">
          <button
            onClick={onClose}
            className="bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-700"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default InventoryDetailsModal;